<template>
  <div>
    <!-- Start: Banner -->
    <section class="flight">
      <div class="jumbotron jumbo-sm">
        <div class="get-search">
          <div class="container">
            <div class="cBet">
              <div class="search__result-header">
                <div
                  class="flight-route big-text"
                  style="text-transform: capitalize"
                >
                  <div>
                    Hourly Booking<span>&bull;</span>
                    {{
                      searchParameter.isSelfDrive ? "Self Drive" : "Chauffeur"
                    }}
                  </div>
                </div>
                <div class="get-passenger-info">
                  <div>
                    {{ pickUpLocation }} <span>&bull;</span>
                    <template v-if="showRangeDate"
                      >{{ longStartRentDate + " " + shortStartRentTime }} -
                      {{ longEndRentDate + " " + shortEndRentTime }}</template
                    >
                    <template v-if="offsetName"
                      ><span>&bull;</span> {{ offsetName }}</template
                    >
                  </div>
                </div>
              </div>
              <button
                class="btn btn--white mr-15"
                @click="onClickModifySearch()"
              >
                Modify Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Banner -->

    <!-- Start: Content -->
    <section class="car__search-result">
      <div class="container">
        <div class="row">
          <!-- Start: Filter -->
          <div class="col-sm-3 prz">
            <div v-if="!isLoading && countVehicle">
              <div class="filter-box--left">
                <div class="filter-box--header">
                  <i class="ic-settings-horizontal"></i> Filter
                  <a class="reset-button" @click="onClickFilterReset()"
                    >Reset</a
                  >
                </div>
                <div class="car-specification">
                  <div
                    class="form-group"
                    v-if="filter.classes && filter.classes.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Class <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <div
                          class="checkbox"
                          v-for="(item, index) in filter.classes"
                          :key="index"
                        >
                          <label class="w-max-content">
                            <input
                              type="checkbox"
                              v-model="item.isSelected"
                              @change="onChangeApplyFilter(item, 'classes')"
                            />{{ item.text }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="filter.specs && filter.specs.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Car Specification <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <div
                          class="checkbox"
                          v-for="(item, index) in filter.specs"
                          :key="index"
                        >
                          <label class="w-max-content">
                            <input
                              type="checkbox"
                              v-model="item.isSelected"
                              @change="onChangeApplyFilter(item, 'specs')"
                            />{{ item.text }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="filter.brands && filter.brands.length > 0"
                  >
                    <div class="group-filter">
                      <header>
                        <button class="btn btn-block">
                          Brand <i class="ic-chevron-up"></i>
                        </button>
                      </header>
                      <div class="btn-group-checkbox">
                        <div
                          class="checkbox"
                          v-for="(item, index) in filter.brands"
                          :key="index"
                        >
                          <label class="w-max-content">
                            <input
                              type="checkbox"
                              v-model="item.isSelected"
                              @change="onChangeApplyFilter(item, 'brands')"
                            />{{ item.text }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="filter-box--left"
                v-if="filter.sort && filter.sort.length > 0"
              >
                <div class="filter-box--header">
                  <i class="ic-filter"></i> Sort
                </div>
                <div class="form-group">
                  <div class="btn-group-radio">
                    <label
                      class="wrap-radio"
                      v-for="(item, index) in filter.sort"
                      :key="index"
                    >
                      <span>{{ item.text }}</span>
                      <input
                        type="radio"
                        name="sortPrice"
                        :value="item.value"
                        :checked="filter.defaultSort === item.value"
                        v-model="filter.defaultSort"
                        @click="onClickApplySort(item)"
                      />
                      <span class="bullet-mark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End: Filter -->

          <div class="col-sm-9">
            <!-- Start: Widget -->
            <div class="car-result-header" v-if="!isLoading && countVehicle">
              <div class="row cRow">
                <div class="col-sm-3">
                  <strong class="--blue25">
                    {{ countVehicle }} car type(s) available
                  </strong>
                </div>
                <!-- <div class="col-sm-9">
                  <div class="dropandpickup cRow">
                    <div class="col-sm-6 plz">
                      <div class="row">
                        <div class="col-sm-7 prz">
                          <div class="location-pick-up">{{ pickUpLocation }}</div>
                        </div>
                        <div class="col-sm-5 text-right">
                          <div class="rent-date">{{ shortStartRentDate }}</div>
                          <div class="rent-time">{{ shortStartRentTime }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 prz divider-left">
                      <div class="row">
                        <div class="col-sm-7 prz">
                          <div class="location-drop-off">Same Location</div>
                        </div>
                        <div class="col-sm-5 text-right">
                          <div class="rent-date">{{ shortEndRentDate }}</div>
                          <div class="rent-time">{{ shortEndRentTime }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="overlimit-info hidden">
                    <div class="text-info">
                      <span class="info-icon"></span>Returns more than one hour will be
                      charged an overtime fee.
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <!-- End: Widget -->

            <!-- Start: Availability -->
            <div class="car-result">
              <!-- Start: Loader -->
              <ul v-if="isLoading" class="c-list">
                <div class="loader-list" v-for="index in 4" :key="index">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="loader-list--image shine"></div>
                    </div>
                    <div class="col-sm-4 plz">
                      <div class="loader-list--lines shine big-title"></div>
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                    </div>
                    <div class="col-sm-4">
                      <div
                        class="loader-list--lines shine big-title pull-right"
                      ></div>
                    </div>
                  </div>
                  <!-- /.row -->
                  <div class="row">
                    <div class="col-sm-1">
                      <div class="loader-list--circle shine"></div>
                    </div>
                    <div class="col-sm-4">
                      <div class="loader-list--lines shine"></div>
                      <div class="loader-list--lines shine"></div>
                    </div>
                  </div>
                  <!-- /.row -->
                </div>
              </ul>
              <!-- End: Loader -->

              <!-- Start: Self-Drive (Rental Only) -->
              <ul
                v-if="!isLoading && searchParameter.isSelfDrive"
                class="c-list"
              >
                <li
                  class="choose-rate"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <div class="wrap__select-list">
                    <div class="header-box cars">
                      <div class="col-sm-12 pz">
                        <div class="col-sm-3 pz">
                          <div class="cars-brand">{{ item.className }}</div>
                          <div
                            class="model-car"
                            v-if="
                              item.factoryName !== null ||
                              item.brandName !== null
                            "
                          >
                            <span
                              >{{ item.factoryName }} {{ item.brandName }}</span
                            >
                          </div>
                          <img :src="item.imageUri" class="cars-image" alt />
                          <button
                            class="btn btn-info"
                            data-toggle="modal"
                            data-target="#terms-modal"
                          >
                            Rental Terms
                          </button>
                        </div>
                        <div class="col-sm-9 pl-25 divider-left prz">
                          <div class="max-capacity">
                            <div
                              class="capacity-seat"
                              v-if="
                                item.feature && item.feature.paxCapacity > 0
                              "
                            >
                              Pax {{ item.feature.paxCapacity }}
                            </div>
                            <div
                              class="capacity-large-baggage"
                              v-if="
                                item.feature &&
                                item.feature.largeBaggageCapacity > 0
                              "
                            >
                              Large Bag. x{{
                                item.feature.largeBaggageCapacity
                              }}
                            </div>
                            <div
                              class="capacity-baggage"
                              v-if="
                                item.feature &&
                                item.feature.smallBaggageCapacity > 0
                              "
                            >
                              Small Bag. x{{
                                item.feature.smallBaggageCapacity
                              }}
                            </div>
                          </div>
                          <div class="table-responsive table-cars-rate">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th class="text-right bz"></th>
                                  <th class="text-center">
                                    LDW <span>Loss Damage Waiver</span>
                                  </th>
                                  <th class="text-center">
                                    PAI <span>Personal Accident Insurance</span>
                                  </th>
                                  <th class="text-right">
                                    Select Rate<span class="--green35">
                                      <strong>({{ item.currencyCode }})</strong>
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="rate in item.selfDriveRates"
                                  :key="rate.type"
                                >
                                  <td class="bz">Rate {{ rate.type }}</td>
                                  <td class="text-center">
                                    <i
                                      :class="
                                        getSelfDriveClass(rate.items, 'LDW')
                                      "
                                    ></i>
                                  </td>
                                  <td class="text-center">
                                    <i
                                      :class="
                                        getSelfDriveClass(rate.items, 'PAI')
                                      "
                                    ></i>
                                  </td>
                                  <td class="text-right">
                                    {{
                                      printMoney(
                                        getSelfDriveRate(
                                          rate.items,
                                          item.totalFare
                                        )
                                      )
                                    }}
                                    <span>
                                      <a
                                        class="btn btn-primary"
                                        type="submit"
                                        @click="
                                          selectVehicle(item.classId, true)
                                        "
                                      >
                                        Select Car
                                      </a>
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- End: Self-Drive (Rental Only) -->

              <!-- Start: Non Self-Drive (Rental) -->
              <ul
                v-if="!isLoading && !searchParameter.isSelfDrive"
                class="c-list"
              >
                <li v-for="(item, index) in items" :key="index">
                  <div class="wrap__select-list">
                    <div class="header-box cars">
                      <div class="col-sm-8 pz">
                        <div class="col-sm-3 pz">
                          <img :src="item.imageUri" class="cars-image" alt />
                        </div>
                        <div class="col-sm-9 pl-30">
                          <div class="cars-brand">{{ item.className }}</div>
                          <div
                            class="model-car"
                            v-if="
                              item.factoryName !== null ||
                              item.brandName !== null
                            "
                          >
                            <span
                              >{{ item.factoryName }} {{ item.brandName }}</span
                            >
                          </div>
                          <div
                            class="capacity-seat"
                            v-if="item.feature && item.feature.paxCapacity > 0"
                          >
                            Pax {{ item.feature.paxCapacity }}
                          </div>
                          <div
                            class="capacity-large-baggage"
                            v-if="
                              item.feature &&
                              item.feature.largeBaggageCapacity > 0
                            "
                          >
                            Large Bag. x{{ item.feature.largeBaggageCapacity }}
                          </div>
                          <div
                            class="capacity-baggage"
                            v-if="
                              item.feature &&
                              item.feature.smallBaggageCapacity > 0
                            "
                          >
                            Small Bag. x{{ item.feature.smallBaggageCapacity }}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="cars__info-3 text-right">
                          <div>
                            <!-- <div class="label-price">
                              Price for {{ rentDays }}
                            </div> -->
                            <div class="price-value flex-column">
                              <span>
                                {{ item.currencyCode }}
                                {{
                                  $currencyFormat(
                                    item.currencyCode,
                                    item.totalFare
                                  )
                                }}
                              </span>
                              <span
                                class="text-10 --grey45"
                                v-if="hasConversionRate"
                              >
                                {{ conversionRate.currency }}
                                {{
                                  $currencyFormat(
                                    conversionRate.currency,
                                    getLocalCurrency(item.totalFare)
                                  )
                                }}
                              </span>
                            </div>
                            <!-- <div class="label-price">Per hour</div> -->
                            <!-- <div class="includes-info --blue25">
                                  <i class="ic-checklist"></i>
                                  Includes Insurance
                              </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="provider-box">
                      <div class="col-sm-9 plz">
                        <!-- <div class="pull-left">
                          <button
                            class="btn btn-info"
                            data-toggle="modal"
                            data-target="#terms-modal"
                          >
                            Rental Terms
                          </button>
                        </div> -->
                        <span
                          class="badge badge-tagging"
                          v-for="(val, index) in item.rateTaggings"
                          :key="index"
                          :style="`color: ${val.textColor} !important; background: ${val.backgroundColor} !important`"
                          >{{ val.text }}</span
                        >
                      </div>
                      <!-- /.col-sm-7 -->

                      <div class="col-sm-3 prz text-right">
                        <a
                          v-if="!searchParameter.isSelfDrive"
                          class="btn btn-primary"
                          type="submit"
                          @click="selectVehicle(item.selectorId, false)"
                        >
                          Select Car
                        </a>
                      </div>
                      <!-- /.col-sm-5-->
                    </div>
                  </div>
                </li>
              </ul>
              <!-- Start: Non Self-Drive (Rental) -->
            </div>

            <div
              class="includes-info-rental"
              style="font-size: 0.8rem"
              v-if="!isLoading && countVehicle"
            >
              <ul class="title-tncs" style="list-style-type: none">
                <li>Terms and Conditions:</li>
              </ul>
              <ul class="item-tncs" style="padding: 0 15px">
                <li>
                  Quote does not include tolls and parking, which will be
                  charged as incurred post-service.
                </li>
                <li>
                  Additional surcharges may apply for airport pick-up and
                  drop-off, and garage-to-garage travel time.
                </li>
                <li>
                  Extended usage on the day of service will be subject to driver
                  availability. Additional hours will be billed post-service.
                </li>
                <li>Unused hours booked will not be refunded or credited.</li>
                <li>
                  Free cancellation up until 24 hours before pick-up time.
                </li>
              </ul>
            </div>
            <!-- End: Availability -->
          </div>
        </div>

        <div class="row" v-if="!isLoading && !countVehicle">
          <NoTransportationAvailable />
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: Modal -->
    <div class="modal fade modal-dark" role="dialog" id="modifySearch__modal">
      <div class="modal-dialog modal-lg main__search">
        <div class="modal-content">
          <div class="modal-body">
            <rentalForm
              :mode="searchParameter.mode"
              @closeModal="handleCloseModifySearch()"
            />
          </div>
        </div>
      </div>
    </div>

    <confirmModal
      :header="'Still looking for a car?'"
      :content="'We recommend refreshing your results to see up-to-date prices for your search.'"
      :submit-label="'Refresh'"
      @submit="refresh"
    />
    <!-- End: Modal -->
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";
import confirmModal from "@/components/shared/ConfirmModal";
import rentalForm from "@/components/availability/form/Rental";
import NoTransportationAvailable from "@/components/shared/NoTransportationAvailable";
import inquiryAvailabilityService from "@/services/shop/availability/inquiryAvailabilityService.js";
import maverickAutoComplete from "@/plugins/google/autocomplete.js";
import availabilityFilter from "@/plugins/availabilityFilter.js";
import { convertFromMarketFx } from "@/helpers/numberHelper.js";
import { Currencies } from "@/models/constants";
import companyService from "@/services/master/company/companyService.js";

export default {
  components: {
    confirmModal,
    rentalForm,
    NoTransportationAvailable,
  },
  data() {
    return {
      offsetName: null,
      autocomplete: null,
      correlationId: null,
      items: [],
      isLoading: false,
      searchParameter: { mode: "" },
      moneyFormat: null,
      isInquiry: true,
      rentDays: null,
      filter: {
        classes: [],
        specs: [],
        brands: [],
        sort: [],
        defaultSort: null,
      },
      showRangeDate: false,
      rentRangeDate: {
        startRent: {},
        endRent: {},
      },
      filterHelper: null,
      refreshTimer: null,
      conversionRate: null,
      services: {},
      companies: [],
    };
  },
  computed: {
    hasConversionRate: function () {
      return this.conversionRate && this.conversionRate !== null;
    },
    pickUpLocation: function () {
      return this.searchParameter.location.address
        ? this.searchParameter.location.address.split(",")[0]
        : "";
    },
    shortStartRentDate: function () {
      return this.$helper.toDateString(this.rentRangeDate.startRent, "D MMM");
    },
    shortEndRentDate: function () {
      return this.$helper.toDateString(this.rentRangeDate.endRent, "D MMM");
    },
    shortStartRentTime: function () {
      return (
        this.rentRangeDate.startRent &&
        this.$helper.toDateString(this.rentRangeDate.startRent, "h:mm A")
      );
    },
    shortEndRentTime: function () {
      return (
        this.rentRangeDate.endRent &&
        this.$helper.toDateString(this.rentRangeDate.endRent, "h:mm A")
      );
    },
    longStartRentDate: function () {
      return (
        this.rentRangeDate.startRent &&
        this.$helper.toDateString(
          this.rentRangeDate.startRent,
          "ddd, D MMM yyyy"
        )
      );
    },
    longEndRentDate: function () {
      return (
        this.rentRangeDate.endRent &&
        this.$helper.toDateString(this.rentRangeDate.endRent, "ddd, D MMM yyyy")
      );
    },
    countVehicle: function () {
      return this.items.length;
    },
  },
  async created() {
    this.$helper.scrollTop();
    // subscribe message
    this.$eventBus.$on("executeModifySearchRental", (newQuery) => {
      $("#modifySearch__modal").modal("hide");
      this.getAvailabilities(newQuery);
      this.$router.replace({ query: newQuery });
    });
    await this.getAvailabilities(this.$route.query);
    const { services } = await this.$store.dispatch("user/getProfile");
    this.services = services;
    this.getAllCompanies();
  },
  beforeDestroy() {
    this.$eventBus.$off("executeModifySearchRental");
    // unsubcribe partialview's eventbus
    this.$eventBus.$off("bindVehicleRental");
  },
  mounted() {
    // creates map instance
    this.autocomplete = new maverickAutoComplete();
  },
  methods: {
    async getAllCompanies() {
      this.companies = await companyService.getAllActive();
    },
    getLocalCurrency(originalCurrency) {
      return convertFromMarketFx(
        originalCurrency,
        this.conversionRate.conversionRate,
        this.conversionRate.conversionFormula
      );
    },
    onClickModifySearch() {
      // publish message
      this.$eventBus.$emit(
        "bindVehicleRental",
        this.searchParameter,
        this.services,
        this.companies,
        true
      );

      $("#modifySearch__modal").modal({ backdrop: "static", keyboard: false });
      $("#modifySearch__modal").css("overflow-y", "auto");
    },
    handleCloseModifySearch() {
      $("#modifySearch__modal").modal("hide");
    },
    initRefreshTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(() => {
        $("#modifySearch__modal").modal("hide");
        $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
      }, this.$helper.fromMinutestoMilliseconds(29));
    },
    async refresh() {
      await this.getAvailabilities(this.$route.query);
    },
    async getAvailabilities(query) {
      try {
        this.isLoading = true;
        this.showRangeDate = false;
        // missing URL parameters
        if (this.$helper.isEmpty(query)) {
          this.$helper.redirectToServerError(this);
          return;
        }
        // missing operation type on URL
        if (!query.svc) {
          this.$helper.redirectToServerError(this);
          return;
        }
        this.searchParameter = {
          location: {
            latitude: parseFloat(query.plt),
            longitude: parseFloat(query.plg),
            name: query.pnm,
            address: query.pad,
            country: query.pcn,
            isAirportZone:
              typeof query.pia === "boolean" ? query.pia : query.pia == "true",
          },
          startRent: this.$helper.toMaverickDateTime(query.str),
          // endRent: this.$helper.toMaverickDateTime(query.enr),
          isSelfDrive:
            query.slf && query.slf.toString().toLocaleLowerCase() === "true",
          durationInHour: query.duration,
          mode: query.mode,
          companyId: query.company || null,
        };
        // get availabilities from API
        const response = await inquiryAvailabilityService.searchVehicleRental(
          this.searchParameter
        );

        this.conversionRate = response.conversionRate;
        this.correlationId = response.correlationId;
        this.items = response.vehicles;
        this.rentDays = response.rentDays;
        this.moneyFormat = response.moneyFormat;
        this.offsetName = response.startRent.offsetName;
        this.rentRangeDate = {
          startRent: response.startRent,
          endRent: response.endRent,
        };
        this.showRangeDate = true;

        this.filterHelper = new availabilityFilter();
        const filterResult = this.filterHelper.populate(this.items);
        this.filter.classes = filterResult.classes;
        this.filter.specs = filterResult.specs;
        this.filter.brands = filterResult.brands;
        this.filter.sort = filterResult.sort;
        this.filter.defaultSort = filterResult.sort[0].value;

        this.initRefreshTimer();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async selectVehicle(selectorId, selfDriveRateType) {
      try {
        this.isLoading = true;
        const response = await inquiryAvailabilityService.selectVehicle({
          serviceType: "rental",
          correlationId: this.correlationId,
          selectorId: selectorId,
          selfDriveRateType: 0,
          // selfDriveRateType: selfDriveRateType,
        });
        this.$router.push({
          name: "InquiryReservationFormRental",
          params: { id: response },
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    getSelfDriveClass(items, code) {
      return items.find((x) => x.code === code) ? "ic-check" : "ic-close";
    },
    getSelfDriveRate(items, grandTotal) {
      return items.reduce((a, b) => {
        return a + b.rate;
      }, grandTotal);
    },
    onChangeApplyFilter(item, selector) {
      this.items = this.filterHelper.applyFilter(
        item,
        selector,
        this.filter.defaultSort
      );
    },
    onClickApplySort(item) {
      return this.filterHelper.applySort(this.items, item.value);
    },
    onClickFilterReset() {
      this.items = this.filterHelper.reset();
      this.filter.defaultSort = this.filter.sort[0].value;
      for (let i = 0; i < this.filter.classes.length; i++) {
        this.filter.classes[i].isSelected = false;
        this.filter.classes[i].isEnable = true;
      }
      for (let i = 0; i < this.filter.specs.length; i++) {
        this.filter.specs[i].isSelected = false;
        this.filter.specs[i].isEnable = true;
      }
      for (let i = 0; i < this.filter.brands.length; i++) {
        this.filter.brands[i].isSelected = false;
        this.filter.brands[i].isEnable = true;
      }
    },
  },
};
</script>
<style scoped>
ul.title-tncs {
  color: #212121;
  font-size: 16px;
  font-weight: 600;
}
ul.item-tncs {
  color: #777777;
  font-size: 15px;
  font-weight: 400 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/availability/result/inquiry/ResultRental.vue